export default {
  search: 'Search types',
  deleteConfirmationTitle: 'Delete hospital type',
  deleteConfirmationText: 'Do you really want to delete hospital type?',
};
